import { Box, Checkbox, Grid, Paper, Typography } from "@mui/material";
import React  from "react";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const SelectRecipeTable = ({
  setSelectedRecipeData,
  selectedRecipeData,
  RecipeData,
  Column1,
  Column2,
  column3,
  Column4,
}) => {
  const handleCheckboxChange = (e, recipeIndex) => {
    const isChecked = e.target.checked;
    // Create a copy of the current selectedRecipeData state
    const updatedSelectedData = [...selectedRecipeData];

    if (isChecked) {
      // Add the selected recipe to the array
      updatedSelectedData.push(RecipeData[recipeIndex]);
    } else {
      // Remove the unselected recipe from the array
      const indexToRemove = updatedSelectedData.findIndex(
        (selectedRecipe) => selectedRecipe.id === RecipeData[recipeIndex].id
      );
      if (indexToRemove !== -1) {
        updatedSelectedData.splice(indexToRemove, 1);
      }
    }
    setSelectedRecipeData(updatedSelectedData);
  };

  return (
    <>
      
      <Box>
   
        <Box
          sx={{
            boxShadow: "none",
            outline: "none",
            mb: "10px",
            border: "none",
            mt: "30px",
            boxSizing: "border-box",
          }}
        >
          <Grid container>
            {/* first column */}
            <Grid item xs={0.5} md={0.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",
                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  {Column1}
                </Typography>
              </Paper>
            </Grid>

            {/* Second Column */}

            <Grid item xs={2} md={2}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  {Column2}
                </Typography>
              </Paper>
            </Grid>

            {/* Third Column */}

            <Grid item xs={7.5} md={7.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  {column3}
                </Typography>
              </Paper>
            </Grid>

            {/* Fourth Column */}

            <Grid item xs={2} md={2}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  {Column4}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            overflow: "auto",
            minHeight: "100px",
            maxHeight: "415px",
            "&:hover": {
              "::-webkit-scrollbar": {
                width: "5px",
                borderRadius: "10px",
              },
              "::-webkit-scrollbar-thumb": {
                bgcolor: "gray",
                borderRadius: "10px",
              },
            },
          }}
        >
          <Grid container>
            {/* first column */}
            <Grid item xs={0.5} md={0.5}>
              {RecipeData.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                    }}
                  >
                    {i + 1}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Second Column */}

            <Grid item xs={2} md={2}>
              {RecipeData.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box sx={{ width: "40px", height: "40px" }}>
                    <img
                      width={"100%"}
                      height={"100%"}
                      src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.recipe_images[0].r_images}`}
                      alt=""
                    />
                  </Box>
                </Paper>
              ))}
            </Grid>

            {/* Third Column */}

            <Grid item xs={7.5} md={7.5}>
              {RecipeData.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "100%",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    {e.title}
                  </Typography>
                </Paper>
              ))}
            </Grid>

            {/* Sixth Column */}
            <Grid item xs={2} md={2}>
              {RecipeData.map((e, i) => (
                <Paper
                  key={i}
                  sx={{
                    borderRadius: "0px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Checkbox
                      checked={selectedRecipeData.some(
                        (selectedRecipe) => selectedRecipe.id === e.id
                      )}
                      onChange={(e) => handleCheckboxChange(e, i)} // Pass the recipe object to the handler
                      icon={<RadioButtonUncheckedIcon fontSize="medium" />}
                    />
                  </Box>
                </Paper>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default SelectRecipeTable;
